<template>
  <v-toolbar flat>
    <v-btn
      fab
      text
      @click="$router.go(-1)"
    >
      <v-icon>keyboard_backspace</v-icon>
    </v-btn>
    <v-spacer />
    <h4>{{ pointInfo }}</h4>
    <v-spacer />
    <v-toolbar-items class="hidden-sm-and-down">
      <template v-for="tab in pointTabs">
        <v-btn
          text
          :to="'/points/' + point_id + tab.path"
          :key="tab.title"
        >
          {{ tab.title }}
        </v-btn>
      </template>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  name: 'PointToolbar',
  props: {
    pointInfo: {}
  },
  data () {
    return {
      point_id: this.$route.params['id'],
      pointTabs: [
        { icon: '', title: 'Основное', path: '/edit' },
        { icon: '', title: 'Потребление', path: '/consumption' },
        { icon: '', title: 'Фазы', path: '/phase' },
        { icon: '', title: 'Счетчики', path: '/counters' },
        { icon: '', title: 'Расписание', path: '/scheduler' },
      ]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/spa/points/PointToolbar.vue